import { Tag } from '../types';

export const BASE_TAGS_ICONS_URL =
    'https://fiverr-res.cloudinary.com/image/upload/v1584948052/listings_assets/non_exp_di';

/**
 * Returns the icon url for a given tag
 */
export const buildTagIconUrl = (tag: Tag): string => {
    switch (tag.type) {
        case 'simple':
            return '';
        case 'skill':
            return `${BASE_TAGS_ICONS_URL}/${tag.subCategoryId}_${tag.id}.svg`;
        case 'metadata':
            return `${BASE_TAGS_ICONS_URL}/${tag.key}_${tag.value}.svg`;
        default:
            return '';
    }
};
